import React from 'react'
// import styled from 'styled-components'

import { CompensationLineProps } from '../items/CompensationLine'
// import ItemBox from '../items/ItemBox'

/**
 * 補償画面で利用する補償項目の一覧
 */
const CompensationList: React.FC = () => {
  return (
    <React.Fragment>
      {/* {props.items.map((group, index) => (
        <CompensationLineArea key={index} isRequested={props.isRequested}>
          <ItemBox>
            <CompensationContentArea>
              {group.map((item, innerIndex) => (
                <CompensationLine key={`${index}_${innerIndex}`} {...item} />
              ))}
            </CompensationContentArea>
          </ItemBox>
        </CompensationLineArea>
      ))} */}
    </React.Fragment>
  )
}

export type CompensationListProps = {
  items: Array<Array<CompensationLineProps>>
  isRequested?: boolean
}

// const CompensationLineArea = styled.div<{ isRequested?: boolean }>`
//   ${(props): string =>
//     props.isRequested
//       ? `
//     margin-bottom: -1px;
//     &&:last-child {
//       margin-bottom: 0;
//     }
//   `
//       : `
//     margin-bottom: 16px;
//     &&:last-child {
//       margin-bottom: 0;
//     }
//   `}
// `

// const CompensationContentArea = styled.div`
//   padding-top: 24px;
//   padding-right: 16px;
//   padding-bottom: 16px;
//   padding-left: 16px;
// `

export default React.memo<CompensationListProps>(CompensationList)
